// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"f7f79cec","285":"f7f79cec","415":"f7f79cec","727":"f4c0db6d"}[chunkId] + ".chunk.css";
};